
if(document.getElementsByClassName('selectActionButton-Download').length >=0){
    require('es6-promise').polyfill();
    require('isomorphic-fetch');
    require('./download.js');
}
